<bnd-modal
  [open]="open()"
  size="sm"
>
  <p class="flex flex-col items-center justify-center">
    @if (isUpdateInProgress) {
      <div>{{ 'DIALOG.UPDATE.MESSAGE_IN_PROGRESS' | translate }}</div>
      <bnd-loading size="lg" />
    } @else {
      {{ 'DIALOG.UPDATE.MESSAGE' | translate }}
    }
  </p>

  <div
    modal-footer
    class="flex justify-end"
  >
    <bnd-button
      color="primary"
      (click)="reload()"
    >
      {{ 'DIALOG.UPDATE.RELOAD' | translate }}
    </bnd-button>
  </div>
</bnd-modal>
